export const product = {
  name: "Yellowtime Sales Crawler",
  company: "Yellowtime",
  mark: "YT",
  service: "yellowtime-sales-crawler",
  description: "Lead Discovery, Bedarfssignale und Sales-Priorisierung."
} as const;
